let load = require('./helpers/browser/esm-js-loader-shards-super.js')(4);
module.exports = (load("9nJ4L")).then(() => parcelRequire('h4Ez5'));